import { ImportExternalErpContainersFlow } from '@Components/Stammdaten';
import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { containerColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useExternalErpImport } from '@Hooks/Stammdaten/useExternalErpImport';
import { EnumFrontendLayoutSetting, type ApiContainer } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ContainersRepository } from '@Repositories/Stammdaten';

export function FrameListContainer() {
    const hasPermission = useHasPermission();
    const module = useListApi(ContainersRepository, STAMMDATEN_API);

    const { toolbarElements, flowProps, tableKey } = useExternalErpImport('Container importieren');

    return (
        <>
            <TableWithStoredSettingsAndLayoutSettings<ApiContainer>
                layoutSettingsContext={EnumFrontendLayoutSetting.ContainersTableLayout}
                name="ContainerList"
                columns={containerColumns}
                loader={module.loadPage}
                canCreate={hasPermission(Permission.StammdatenContainerCreate)}
                key={tableKey}
                useOnClickNavigation
                fullSize
                toolbarElements={toolbarElements}
            />
            <ImportExternalErpContainersFlow {...flowProps} />
        </>
    );
}
